import React from 'react';
import PageWrapper from '../../components/PageWrapper';
import { useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { Box, Typography } from '@mui/material';
import { useOrderGetInfoQuery } from '../../services/orders';
import { QuickOrderTotals } from './components/OrderPaymentTotals';
import { useAuthEffects } from '../../components/Auth';
import useAuth from '../../components/Auth';
import { SimpleList } from '../../components/SimpleList';
import { useTranslation } from 'react-i18next';
import { Currencies, CURRENCY_SYMBOLS, OrderProduct } from '../../types';
import { ProductDocument } from '../products/types';
import { FileItem } from '../../components/FileItem';

const OrderDetailViewV2 = () => {
	useAuthEffects();
	const navigate = useNavigate();
	const {id} = useParams();
	const {userProfile, isAuthLoading} = useAuth();
	const {t} = useTranslation();
	const {data: order, isLoading} = useOrderGetInfoQuery(id as string, {skip: !id || !userProfile});

	const redirectToHome = () => {
		navigate('/');
	};

	useEffect(() => {
		if (userProfile && !isLoading && !order || !isAuthLoading && !userProfile) {
			redirectToHome();
		}
	}, [isLoading, userProfile, order, isAuthLoading]);

	return <PageWrapper isLoading={!order} loadingMessage="Loading order..." maxWidth='md'>
		<Box display="flex" justifyContent="center" alignItems="center" flexDirection="column" gap={2} p={4}>
			<Typography variant="h4">Thank you for your purchase!</Typography>
			<div>
				<Typography variant="h6">Order ID: {order?.id}</Typography>
			</div>
		</Box>
		<SimpleList items={order?.products.map((product: OrderProduct) => ({
			id: product.id,
			imgUrl: product.imgUrl,
			label: product.name,
			secondary: `${CURRENCY_SYMBOLS[order?.currency as Currencies]}${product.pricePerUnit}`,
			properties: [
				{label: product.quantity.toString(), secondary: t(`uom.${product.uom}`)},
			],
			additionalInfo: Boolean(product.documents.length) && <Box display="flex" flexDirection="row" gap={1} flexWrap="wrap" my={1}>
				{product.documents.map((document: ProductDocument) => (
					<FileItem key={document.id} document={document} />
				))}
			</Box>
		})) || []} />
		<QuickOrderTotals 
			products={order?.products || []}
			additionalFees={order?.additionalFees || []}
			currency={Currencies.EUR} // TODO: get currency from orderInfo
		/>
	</PageWrapper>;
};

export default OrderDetailViewV2;